import React from 'react'
import styles from './OverlayPicker.scss'
import Select from 'react-select'
import { tileServices } from 'lib/tileServices'
import { injectIntl } from 'react-intl'

const optionsForSelect = (intl, rwgpsOverlaysOnly) => Object.values(tileServices)
  .filter(s => rwgpsOverlaysOnly ? s.type !== 'google' : s)
  .map(
    service => {
      const label = service.intlName
        ? intl.formatMessage(service.intlName)
        : service.name
      return { label, value: service.id }
    }
  )

class _OverlayPicker extends React.PureComponent {
  render () {
    const { overlay, onPickOverlay, rwgpsOverlaysOnly, intl } = this.props
    return (
      <div className={styles.OverlayPicker}>
        <Select
          clearable={false}
          searchable={false}
          value={overlay.id}
          onChange={(o) => onPickOverlay(tileServices[o.value])}
          options={optionsForSelect(intl, rwgpsOverlaysOnly)} />
      </div>
    )
  }
}

export const OverlayPicker = injectIntl(_OverlayPicker)
